import React, { useEffect, useState } from "react";
import { Form, Modal } from "antd";
import type { ModalProps } from "antd";
import { IOfferingGroup } from "../../types/IOfferingGroup";
import { IOfferingGroupsSearch } from "../../types/IOfferingGroupsSearch";
import { OfferingGroupsSearch } from "../OfferingGroupsSearch/OfferingGroupsSearch";
import { OfferingGroupsSearchTable } from "../OfferingGroupsSearchTable/OfferingGroupsSearchTable";
import { useAppDispatch } from "../../../..";
import { offeringGroupsActions, searchOfferingGroups } from "../../store/slice/offeringGroupsSlice";
import { toHttpFormatStartOfDay } from "../../../../lib/utils";
import "./OfferingGroupsSearchModal.less";

interface ComponentProps {
  visible: boolean;
  policyTypeId?: number;
  isParamPlace?: "first" | "second";
  onSubmit: (offeringGroup: IOfferingGroup) => void;
  onCancel: () => void;
}

export const OfferingGroupsSearchModal = (props: ComponentProps) => {
  const { visible, policyTypeId, isParamPlace, onCancel, onSubmit } = props;

  const dispatch = useAppDispatch();

  const [searchForm] = Form.useForm<IOfferingGroupsSearch>();

  const [selectedGroup, setSelectedGroup] = useState<IOfferingGroup>();

  const onResetSearch = () => {
    dispatch(offeringGroupsActions.cleanOfferingGroups());
    searchForm.resetFields();
    setSelectedGroup(undefined);
  };

  const [isSearchOpen, setIsSearchOpen] = useState(true);

  const toggleSearchOpen = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const hadnleSubmit = (selectedGroup: IOfferingGroup) => {
    onSubmit(selectedGroup);
    dispatch(offeringGroupsActions.cleanOfferingGroups());
  };

  const handleCancel = () => {
    onCancel();
    dispatch(offeringGroupsActions.cleanOfferingGroups());
  };

  const onSearch = () => {
    setSelectedGroup(undefined);
    const searchValues: IOfferingGroupsSearch = searchForm.getFieldsValue();
    dispatch(
      searchOfferingGroups({
        ...searchValues,
        onDate: toHttpFormatStartOfDay(searchValues.onDate),
        page: 0,
        size: 100,
      })
    );
  };

  const modalProps: ModalProps = {
    visible,
    width: "100%",
    okButtonProps: {
      style: {
        width: "108px",
      },
      onClick: () => {
        if (selectedGroup) {
          hadnleSubmit(selectedGroup);
        }
      },
      disabled: !selectedGroup,
    },
    cancelButtonProps: {
      style: {
        width: "108px",
      },
      onClick: handleCancel,
    },
    onCancel: handleCancel,
  };

  return (
    <Modal className="offering-groups-search-modal" {...modalProps}>
      <h1>Выбор группы</h1>
      <OfferingGroupsSearch
        isSearchOpen={isSearchOpen}
        policyTypeId={policyTypeId}
        isParamPlace={isParamPlace}
        toggleSearchOpen={toggleSearchOpen}
        searchForm={searchForm}
        onResetSearch={onResetSearch}
        onSearch={onSearch}
      />
      <OfferingGroupsSearchTable
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
        isSearchOpen={isSearchOpen}
      />
    </Modal>
  );
};
